import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import ModalLayout from './modalLayout';
import { useTranslation } from 'react-i18next';
import { SettingsBody } from '../chat/settings';
import { closeModal, getSettingsForGroup, updateSettings } from '../../../redux/reducers';

const SettingsModal = ({ open, mode, ...rest }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [oldValues, setOldValues] = useState(null);
  const currentValues = useSelector(getSettingsForGroup(mode), shallowEqual);
  useEffect(() => {
    if (open) {
      // when settings modal is opened, save current values so we can revert if needed
      setOldValues(currentValues);
    } else {
      // revert, if not saved
      if (oldValues) {
        dispatch(updateSettings(oldValues));
      }
    }
  }, [open]);

  const onSubmit = useCallback(() => {
    setOldValues(null);
    dispatch(closeModal());
  }, [dispatch]);

  const onClose = useCallback(() => dispatch(closeModal()), [dispatch]);

  return (
    <ModalLayout
      open={open}
      headerText={t('chat.settings.header')}
      leftButtonProps={{ bg: null }}
      rightButtonProps={{ color: 'white' }}
      footerProps={{ borderTop: 'none' }}
      leftButtonText={rest.leftButtonText || t('modal.cancel')}
      rightButtonText={rest.rightButtonText || t('modal.save')}
      modalProps={{ closeOnOverlayClick: false }}
      onClose={onClose}
      size="xl"
      displayFooter={false}
    >
      <SettingsBody onClose={onClose} onSubmit={onSubmit} mode={mode} />
    </ModalLayout>
  );
};

SettingsModal.propTypes = {
  open: PropTypes.bool,
  mode: PropTypes.string,
};

SettingsModal.defaultProps = {
  open: false,
};

export default SettingsModal;
